<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Authentication - Sign-in -->
    <div
      class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
      :style="{
        backgroundImage:
          'url(' +
          `${publicPath}assets/media/illustrations/sketchy-1/14.png ` +
          ')',
      }"
    >
      <!--begin::Content-->
      <div
        class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20"
      >
        <!--begin::Logo-->
        <a href="../../demo1/dist/index.html" class="mb-12">
          <img alt="Logo" :src="`${publicPath}logo.png`" class="h-40px" />
        </a>
        <!--end::Logo-->
        <!--begin::Wrapper-->
        <div class="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
          <!--begin::Form-->
          <form
            @submit.prevent="signIn"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            action="#"
          >
            <!--begin::Heading-->
            <div class="text-center mb-10">
              <!--begin::Title-->
              <h1 class="text-dark mb-3">لوحة تحكم جيران</h1>
              <!--end::Title-->
              <div
                v-if="invalidData == false"
                class="alert alert-warning"
                role="alert"
              >
                اسم المستخدم او كلمة السر خطأ
              </div>
              <!--begin::Link-->
              <!--              <div class="text-gray-400 fw-bold fs-4">New Here?-->
              <!--                <a href="../../demo1/dist/authentication/layouts/basic/sign-up.html" class="link-primary fw-bolder">Create an Account</a></div>-->
              <!--end::Link-->
            </div>
            <!--begin::Heading-->
            <!--begin::Input group-->
            <div class="fv-row mb-10">
              <!--begin::Label-->
              <div class="d-flex flex-stack mb-2">
                <label class="form-label fs-6 fw-bolder text-dark">{{
                  $t("email")
                }}</label>
              </div>
              <!--end::Label-->
              <!--begin::Input-->
              <input
                class="form-control form-control-lg form-control-solid"
                type="text"
                name="email"
                required
                v-model="form.mobile_or_email"
                autocomplete="off"
              />
              <!--end::Input-->
            </div>
            <!--end::Input group-->
            <!--begin::Input group-->
            <div class="fv-row mb-10">
              <!--begin::Wrapper-->
              <div class="d-flex flex-stack mb-2">
                <!--begin::Label-->
                <label class="form-label fw-bolder text-dark fs-6 mb-0">{{
                  $t("password")
                }}</label>
                <!--end::Label-->
                <!--begin::Link-->
                <!--                <a href="../../demo1/dist/authentication/layouts/basic/password-reset.html" class="link-primary fs-6 fw-bolder">Forgot Password ?</a>-->
                <!--end::Link-->
              </div>
              <!--end::Wrapper-->
              <!--begin::Input-->
              <input
                class="form-control form-control-lg form-control-solid"
                type="password"
                name="password"
                required
                v-model="form.password"
                autocomplete="off"
              />
              <!--end::Input-->
            </div>
            <!--end::Input group-->
            <!--begin::Actions-->
            <div class="text-center">
              <!--begin::Submit button-->
              <button
                type="submit"
                id="kt_sign_in_submit"
                :disabled="!invalidForm"
                class="btn btn-lg btn-primary w-100 mb-5"
              >
                <span class="indicator-label">{{ $t("continue") }}</span>
                <span class="indicator-progress"
                  >Please wait...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span
                ></span>
              </button>
              <!--end::Submit button-->
              <!--begin::Separator-->
              <!--              <div class="text-center text-muted text-uppercase fw-bolder mb-5">or</div>-->
              <!--              &lt;!&ndash;end::Separator&ndash;&gt;-->
              <!--              &lt;!&ndash;begin::Google link&ndash;&gt;-->
              <!--              <a href="#" class="btn btn-flex flex-center btn-light btn-lg w-100 mb-5">-->
              <!--                <img alt="Logo" src="assets/media/svg/brand-logos/google-icon.svg" class="h-20px me-3" />Continue with Google</a>-->
              <!--              &lt;!&ndash;end::Google link&ndash;&gt;-->
              <!--              &lt;!&ndash;begin::Google link&ndash;&gt;-->
              <!--              <a href="#" class="btn btn-flex flex-center btn-light btn-lg w-100 mb-5">-->
              <!--                <img alt="Logo" src="assets/media/svg/brand-logos/facebook-4.svg" class="h-20px me-3" />Continue with Facebook</a>-->
              <!--              &lt;!&ndash;end::Google link&ndash;&gt;-->
              <!--              &lt;!&ndash;begin::Google link&ndash;&gt;-->
              <!--              <a href="#" class="btn btn-flex flex-center btn-light btn-lg w-100">-->
              <!--                <img alt="Logo" src="assets/media/svg/brand-logos/apple-black.svg" class="h-20px me-3" />Continue with Apple</a>-->
              <!--end::Google link-->
            </div>
            <!--end::Actions-->
          </form>
          <!--end::Form-->
        </div>
        <!--end::Wrapper-->
      </div>
      <!--end::Content-->
      <!--begin::Footer-->
      <!--      <div class="d-flex flex-center flex-column-auto p-10">-->
      <!--        &lt;!&ndash;begin::Links&ndash;&gt;-->
      <!--        <div class="d-flex align-items-center fw-bold fs-6">-->
      <!--          <a href="https://keenthemes.com" class="text-muted text-hover-primary px-2">About</a>-->
      <!--          <a href="mailto:support@keenthemes.com" class="text-muted text-hover-primary px-2">Contact</a>-->
      <!--          <a href="https://1.envato.market/EA4JP" class="text-muted text-hover-primary px-2">Contact Us</a>-->
      <!--        </div>-->
      <!--        &lt;!&ndash;end::Links&ndash;&gt;-->
      <!--      </div>-->
      <!--end::Footer-->
    </div>
    <!--end::Authentication - Sign-in-->
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      form: {},
    };
  },
  methods: {
    signIn() {
      console.log(this.$store.dispatch("login", this.form));
    },
  },
  computed: {
    invalidData() {
      return this.$store.state.loggedIn;
    },
    invalidForm() {
      return this.form.mobile_or_email != "" || this.form.password != "";
    },
  },
};
</script>

<style scoped></style>
